import { Snackbar, Alert } from "@mui/material";
import { useToastStore } from "./toastStore";

export default function ToastHost() {
  const { queue, shift } = useToastStore();
  const current = queue[0];

  const handleClose = () => {
    shift();
  };

  return (
    <Snackbar
      open={!!current}
      key={current?.id ?? undefined}
      autoHideDuration={4000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      {current ? (
        <Alert onClose={handleClose} severity={current.severity} sx={{ width: "100%" }}>
          {current.message}
        </Alert>
      ) : undefined}
    </Snackbar>
  );
}
